module.exports = __webpack_public_path__ + "static/the-moth-presents-all-these-wonders-8ebd8c532b28afd24f9c07585bc9fe00.jpg";